'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.default = {
  dataIterator: {
    rowsPerPageText: 'Elemente pro Seite:',
    rowsPerPageAll: 'Alle',
    pageText: '{0}-{1} von {2}',
    noResultsText: 'Keine Elemente gefunden',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite'
  },
  dataTable: {
    rowsPerPageText: 'Zeilen pro Seite:'
  },
  noDataText: 'Keine Daten vorhanden',
  lobis: {
    login: 'Anmelden',
    request_code: 'Code anfordern',
    go_back: 'Zurück',
    code_requeired: 'Bitte einen Code eingeben',
    phonenumber_requeired: 'Bitte eine Telefonnummer eingeben',
    noResultsForPosition: 'Für diese Position gibt es noch keine Einträge.',
    billingAmount: 'Abzurechnender Betrag',
    editTimeEntry: 'Arbeitszeit bearbeiten',
    addTimeEntry: 'Arbeitszeit eintragen',
    selectCustomer: 'Kunde auswählen',
    queryCustomer: 'Nach Kunde suchen..',
    selectProject: 'Projekt auswählen',
    queryProject: 'Nach Projekt suchen..',
    cancel: 'Abbrechen',
    ok: 'Ok',
    squaremeters: 'Quadratmeter',
    orders: 'Aufträge',
    note: 'Bemerkung',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    sending: 'Wird übertragen..',
    addedSuccessfully: 'Eintrag erfolgreich hinzugefügt..',
    timeEntries: 'Zeiten',
    customer: 'Kunde',
    contactPerson: 'Ansprechsperson',
    phoneNumber: 'Telefonnummer',
    route: 'Anfahrt',
    address: 'Adresse',
    startNavigation: 'Navigation starten',
    myEntriesForPosition: 'Meine Einträge zu dieser Position',
    insertCode: 'Code eingeben',
    language: 'Sprache',
    history: 'History',
    manualEntry: 'Manueller Eintrag',
    workreport: 'Regie',
    date: 'Datum',
    begin: 'Beginn',
    end: 'Ende',
    duration: 'Dauer',
    qtyDone: 'Gemachte {0}',
    qty: 'Menge',
    settings: 'Einstellungen',
    italian: 'Italiano',
    german: 'Deutsch',
    planned_hours_cold: 'Geplante Stunden Kalte Böden',
    planned_hours_warm: 'Geplante Stunden warme Böden',
    logout: 'Abmelden',
    logoutconfirmation: 'Bist du sicher?',
    planner: 'Planer',
    billinglist: 'Nachmessen'
  }
}
// # sourceMappingURL=de.js.map



// WEBPACK FOOTER //
// ./src/lang/de.js